import mergeImages from "merge-images";
import config from "lib/fr-config";
import imageCropper from "lib/imageCropper";
import { blobToDataURL } from "blob-util";

const IMAGE_QUALITY = config.uploadImageQuality.outfit;

/**
 * [입력 객체.]
 * inputObj = {
 *   background: (image),
 *   sticker: (image) or null,
 *   loc: { x: (number), y: (number) } // 0~1 사이의 수. 배경이미지 대비 좌표 퍼센트.
 * }
 */
const stickerMerger = async inputObj => {
  const returnImg = mergeImages(await _getImageStackArray(inputObj), {
    format: "image/jpeg",
    quality: IMAGE_QUALITY
  });
  return returnImg;
};

const _getImageStackArray = async ({ background, sticker, loc }) => {
  const imageArray = [background];

  if (sticker) {
    imageArray.push(await _getResizedStickerObj({ background, sticker, loc }));
  }

  return imageArray;
};

const _getResizedStickerObj = async ({ background, sticker, loc }) => {
  const { width: bgWidth, height: bgHeight } = await _getImgSize(background);
  const { width, height } = await _calculateStickerSize(bgHeight);
  const stickerElem = await _makeImageElement(sticker);
  const resizedStickerBlob = await imageCropper({
    width,
    height,
    img: stickerElem,
    imageQuality: 1,
    filename: "sticker",
    extension: "png"
  });
  const stickerImgSrc = await blobToDataURL(resizedStickerBlob);

  return {
    src: stickerImgSrc,
    x: (bgWidth - width) * loc.x,
    y: (bgHeight - height) * loc.y
  };
};

const _calculateStickerSize = async height => {
  const { RATIO, heightRatio } = config.stickerImage;
  const stickerHeight = height * heightRatio;
  const stickerWidth = stickerHeight * RATIO;
  return { width: Math.round(stickerWidth), height: Math.round(stickerHeight) };
};

const _getImgSize = async image => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = image;
    img.onload = () => {
      const { width, height } = img;
      resolve({ width, height });
    };
  });
};

const _makeImageElement = src => {
  const returnImg = new Image();
  returnImg.src = src;
  return new Promise((resolve, reject) => {
    returnImg.onload = () => resolve(returnImg);
  });
};

export default stickerMerger;
